function initialiseFooterMenus(root = document) {
  root.querySelectorAll('.footer').forEach((footer) => {
    if (footer.dataset.menusReady) return;
    footer.dataset.menusReady = 'true';
    const desktop = window.matchMedia('(min-width: 990px)');
    const fixedDesktop = () => desktop.matches && !footer.classList.contains('footer--home');
    const menus = Array.from(footer.querySelectorAll('.footer-block--menu'));
    const updateLayout = () => {
      menus.forEach((menu) => {
        menu.open = fixedDesktop();
        const summary = menu.querySelector('summary');
        if (fixedDesktop()) summary.setAttribute('tabindex', '-1');
        else summary.removeAttribute('tabindex');
      });
    };
    updateLayout();
    desktop.addEventListener('change', updateLayout);
    footer.addEventListener('click', (event) => {
      if (fixedDesktop() && event.target.closest('.footer-block--menu summary')) event.preventDefault();
    });
    footer.addEventListener('toggle', (event) => {
      const menu = event.target;
      if (fixedDesktop() || !(menu instanceof HTMLDetailsElement) || !menu.open || !menu.matches('.footer-block--menu')) return;
      menus.forEach((other) => {
        if (other !== menu) other.open = false;
      });
    }, true);
  });
}
initialiseFooterMenus();
document.addEventListener('shopify:section:load', (event) => initialiseFooterMenus(event.target));
